import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import type { Theme } from '../../services/preferences.service';

const NEXT: Record<Theme, Theme> = {
  light: 'dark',
  dark: 'system',
  system: 'light',
};

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const Icon = theme === 'light' ? Sun : theme === 'dark' ? Moon : Monitor;
  const label =
    theme === 'light'
      ? 'Tema: claro (clique para escuro)'
      : theme === 'dark'
        ? 'Tema: escuro (clique para sistema)'
        : 'Tema: sistema (clique para claro)';

  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={() => setTheme(NEXT[theme])}
      className="inline-flex items-center justify-center w-9 h-9 rounded-md text-ink-secondary hover:text-ink-primary hover:bg-subtle transition-colors duration-150"
    >
      <Icon size={18} />
    </button>
  );
}
